<button class="btn-close" (click)="closeModal()">
  <mat-icon>close</mat-icon>
</button>
<mat-toolbar class="mat-elevation-z0">
  <mat-toolbar-row>
    <div class="notificard">
      <h2>
        <img src="assets/images/itinerary.svg" alt="" class="me-2" />
        Cancel {{ data?.tripBy }} {{ data?.operation }}
      </h2>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<div class="side-drawer-content contact">
  <div [formGroup]="formGroup" class="px-3 py-1">
    <ng-container *ngIf="data?.operation == 'Journey'">
      <ng-container formArrayName="cancelTripItineraryHotel">
        <ng-container
          *ngFor="let item of cancelTripItineraryHotel.controls; let i = index"
        >
          <ng-container [formGroupName]="i">
            <div class="col-md-12">
              <p>
                <mat-checkbox formControlName="isCancel" class="example-margin">
                  <div
                    class="d-flex flex-column align-items-start justify-content-center"
                  >
                    <ng-container
                      *ngIf="item?.value.isItinerary; else hotelBlock"
                    >
                      <div class="d-flex align-items-center">
                        {{ item?.value.departureCityName }}
                        <div class="flightcard-icon">
                          @switch (item?.value?.tripBy) { @case ('Flight') {
                          <img
                            src="assets/images/flightcard-icon01.png"
                            alt=""
                          />
                          } @case ('Train') {
                          <img src="assets/images/train-icon.png" alt="" />
                          } @case ('Bus') {
                          <img src="assets/images/bus-icon.png" alt="" />
                          } @case ('Car') {
                          <img src="assets/images/car-icon.png" alt="" />
                          } }
                        </div>
                        {{ item?.value.arrivalCityName }}
                      </div>
                      <div>
                        {{ item?.value.departureDate | date }}
                      </div>
                    </ng-container>
                    <ng-template #hotelBlock>
                      <div class="d-flex align-items-center">
                        <img
                          class="me-2"
                          style="width: 20px"
                          src="assets/images/hotelscard-icon01.png"
                          alt=""
                        />
                        {{ item?.value.cityName }}
                      </div>
                      <div>
                        {{ item?.value.checkIn | date }},
                        {{ item?.value.checkInTime }} -
                        {{ item?.value.checkOut | date }},
                        {{ item?.value.checkOutTime }}
                      </div>
                    </ng-template>
                  </div>
                </mat-checkbox>
              </p>
              @if ((item.value.isCancel && item.value.isGroupTrip)||
              data?.status_request == 'APPROVE') {
              <ng-container formArrayName="cancelTripItineraryHotelUsers">
                <ng-container
                  *ngFor="
                    let group_user of getCancelTripItineraryHotelUsers(i)
                      .controls;
                    let j = index
                  "
                >
                  <ng-container [formGroupName]="j">
                    <div class="col-md-12">
                      <p class="ms-5">
                        <mat-checkbox
                          color="primary"
                          formControlName="isCancelRequest"
                          class="example-margin"
                        >
                          <div
                            class="d-flex flex-column align-items-start justify-content-center"
                          >
                            <div class="d-flex align-items-center">
                              <!-- <img
                          class="me-2"
                          style="width: 20px"
                          src="assets/images/hotelscard-icon01.png"
                          alt=""
                        /> -->
                              {{ group_user?.value.userName }}
                            </div>
                            <div>
                              {{ group_user?.value.email }}
                            </div>
                          </div>
                        </mat-checkbox>
                      </p>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              }
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="data?.operation == 'Specific User'">
      <ng-container formArrayName="groupTripsUsers">
        <ng-container
          *ngFor="let item of groupTripsUsers.controls; let i = index"
        >
          <ng-container [formGroupName]="i">
            <div class="col-md-12">
              <p>
                <mat-checkbox
                  formControlName="isCancelRequest"
                  class="example-margin"
                >
                  <div
                    class="d-flex flex-column align-items-start justify-content-center"
                  >
                    <div class="d-flex align-items-center">
                      <!-- <img
                    class="me-2"
                    style="width: 20px"
                    src="assets/images/hotelscard-icon01.png"
                    alt=""
                  /> -->
                      {{ item?.value.userName }}
                    </div>
                    <div>
                      {{ item?.value.email }}
                    </div>
                  </div>
                </mat-checkbox>
              </p>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="p-3" *ngIf="data.status_request!='VIEW'">
  <button
    *ngIf="data?.operation == 'Journey'"
    type="button"
    class="btn btn-primary w-100"
    (click)="onSubmit($event)"
  >
    <span class="indicator-label">
      {{ data?.status_request == "APPROVE" ? "Approve" : "Cancel" }}
      {{ data?.tripBy }}
      {{ data?.status_request == "APPROVE" ? "Request" : "Request" }}</span
    >
    <span class="indicator-progress"
      >Please wait...
      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
    </span>
  </button>
  <button
    *ngIf="data?.operation == 'Specific User'"
    type="button"
    class="btn btn-primary w-100"
    (click)="specificUserRequestUpdate($event)"
  >
    <span class="indicator-label">
      {{ data?.status_request == "APPROVE" ? "Approve" : "Cancel" }}
      Request</span
    >
    <span class="indicator-progress"
      >Please wait...
      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
    </span>
  </button>
</div>
